import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ShoppingCart, List, X, Gear, InstagramLogo } from "@phosphor-icons/react";
import { useCart } from "../context/CartContext";

const links = [
  { to: "/", label: "Inicio" },
  { to: "/catalogo", label: "Catálogo" },
  { to: "/menu", label: "Menú" },
  { to: "/cata-privada", label: "Cata Privada" },
  { to: "/ventas-mayor", label: "Ventas al Mayor" },
  { to: "/#nosotros", label: "Nosotros" },
  { to: "/#contacto", label: "Contacto" },
];

export const Header = () => {
  const { count } = useCart();
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const nav = useNavigate();

  const go = (to) => {
    setOpen(false);
    if (to.startsWith("/#")) {
      const id = to.slice(2);
      if (loc.pathname !== "/") {
        nav("/");
        setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
      } else {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      nav(to, { state: { ts: Date.now() } });
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-black/85 backdrop-blur-md border-b border-white/10" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
          <div className="w-10 h-10 border border-[#D97736] flex items-center justify-center">
            <span className="font-display text-2xl text-[#D97736] leading-none">CG</span>
          </div>
          <div className="leading-none">
            <div className="font-display text-2xl tracking-wide">CIUDAD GARAJE</div>
            <div className="overline">Cervecería independiente</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.to}
              onClick={() => go(l.to)}
              className="text-sm text-gray-300 hover:text-[#D97736] transition-colors uppercase tracking-widest"
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="https://instagram.com/ciudad.garaje"
            target="_blank"
            rel="noreferrer"
            className="w-10 h-10 flex items-center justify-center text-gray-300 hover:text-[#D97736] transition-colors"
            title="Síguenos en Instagram @ciudad.garaje"
            data-testid="header-instagram"
          >
            <InstagramLogo size={22} weight="fill" />
          </a>
          <Link
            to="/admin"
            className="hidden md:flex w-10 h-10 items-center justify-center text-gray-400 hover:text-[#D97736] transition-colors"
            title="Administración"
            data-testid="admin-link"
          >
            <Gear size={20} weight="bold" />
          </Link>
          <Link
            to="/carrito"
            className="relative w-11 h-11 flex items-center justify-center border border-white/15 hover:border-[#D97736] hover:text-[#D97736] transition-colors"
            data-testid="cart-button"
          >
            <ShoppingCart size={20} weight="bold" />
            {count > 0 && (
              <span
                className="absolute -top-2 -right-2 min-w-5 h-5 px-1 bg-[#D97736] text-black text-xs font-semibold flex items-center justify-center"
                data-testid="cart-count"
              >
                {count}
              </span>
            )}
          </Link>
          <button
            className="md:hidden w-11 h-11 flex items-center justify-center border border-white/15"
            onClick={() => setOpen((o) => !o)}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={20} /> : <List size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/95 px-5 py-4 flex flex-col gap-1" data-testid="mobile-menu">
          {links.map((l) => (
            <button
              key={l.to}
              onClick={() => go(l.to)}
              className="text-left py-3 text-gray-200 uppercase tracking-widest text-sm border-b border-white/5"
            >
              {l.label}
            </button>
          ))}
          <button onClick={() => go("/admin")} className="text-left py-3 text-gray-400 uppercase tracking-widest text-sm">
            Administración
          </button>
          <a
            href="https://instagram.com/ciudad.garaje"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 py-3 text-gray-200 uppercase tracking-widest text-sm"
            data-testid="mobile-instagram"
          >
            <InstagramLogo size={18} weight="fill" className="text-[#D97736]" /> Instagram @ciudad.garaje
          </a>
        </div>
      )}
    </header>
  );
};
